import { nanoid } from 'nanoid';
import axios, { AxiosResponse } from 'axios';
import api from 'app/api';
import { receiveError, toastUpdate } from './showSuccessErrorModal';
import { toast } from 'react-toastify';

export const handleUpload = async (setIsFilesUploading, files, setFiles) => {
  setIsFilesUploading(1);

  const promises = files.map(async file => {
    const info = await fileUpload(file);
    return info;
  });

  const newDocuments = await Promise.all(promises);

  setFiles([]);
  setIsFilesUploading(2);

  return newDocuments;
};

const fileUpload = async (file: File) => {
  try {
    const newFileName = encodeURI(nanoid() + file.name);
    const newFile = new File([file], newFileName, { type: file.type });
    const response: AxiosResponse = await api.get('messages/presigned-url', {
      params: {
        file_name: newFile.name,
        file_type: newFile.type,
      },
      headers: {
        Accept: 'application/json',
        Authorization: localStorage.getItem('_UFT_') as string,
        'Content-Type': 'application/json',
      },
    });
    const { signedRequest, url } = response.data.data;

    // Once we have received the pre-signed URL, we can upload the file to S3
    const result = await uploadFileToS3(newFile, signedRequest);
    const info = {
      name: file.name,
      size: newFile.size,
      type: newFile.type,
      url,
    };
    if (result.success) return info;
    else return '';
  } catch (error) {
    receiveError(error, 'Failed to get the pre-signed URL ');
    return '';
  }

  // If successful, the file is now uploaded. You can get the public URL for this file from 'url' variable
};

const uploadFileToS3 = async (
  file: File,
  signedUrl: string,
): Promise<{ success: boolean; status?: number; statusText?: string }> => {
  if (!signedUrl) {
    console.error('Signed URL is undefined');
    return { success: false };
  }

  const toastId = toast(`Starting upload this ${file.name}...`, {
    progress: 0,
    autoClose: false,
  });

  try {
    const response = await axios.put(signedUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
      onUploadProgress: progressEvent => {
        const total = progressEvent.total;
        const current = progressEvent.loaded;
        if (typeof total === 'number') {
          const percentage = Math.floor((current / total) * 100);
          toastUpdate(file.name, percentage, toastId);
        }
      },
    });
    toast.update(toastId, {
      render: 'Upload complete!',
      type: 'success',
      autoClose: 5000,
    });
    return {
      success: true,
      status: response.status,
      statusText: response.statusText,
    };
  } catch (error) {
    receiveError(error, 'File upload failed: ');
    return { success: false };
  }
};

export default fileUpload;
